<template>
	<label class="form-group buttons m-0">
		<input
			type="file"
			accept="*"
			class="input-file"
			:multiple="multiple"
			@change="onChange">
		<div
			class="btn cur-p"
			:class="[`btn-${btnStyle}`, `btn-${btnSize}`, { 'is-loading': counter > 0 }]">
			{{ label }}
		</div>
	</label>
</template>

<script>
import fileApi from '@/api/file';

export default {
	name: 'FileUploader',
	props: {
		multiple: {
			type: Boolean,
			default: false,
		},
		btnStyle: {
			type: String,
			default: 'primary',
		},
		btnSize: {
			type: String,
			default: 'md', // sm, md, lg
		},
		resize: {
			type: Boolean,
			default: false,
		},
		label: {
			type: String,
			default: 'Upload',
		},
		username: {
			type: String,
			default: 'oo',
		},
	},
	data() {
		return {
			counter: 0,
			progress: [],
		};
	},
	methods: {
		onChange(event) {
			const files = event.target.files;
			for (let index = 0; index < files.length; index++) {
				const file = files[index];
				this.upload(file, index);
			}
		},
		upload(file, index) {
			this.counter++;

			const username = this.username;
			const uploadParams = new FormData();
			uploadParams.append('file', file);
			uploadParams.append('username', username);

			const callback = (response) => {
				this.counter--;
				const path = response.data;
				const fileUrl = `${this.mediaUrlPrefix}/${path}`;
				this.$emit('uploaded', fileUrl, file);
			};

			const errorCallback = () => {
				this.counter--;
			};

			const progressCallback = (percentage) => {
				this.progress[index] = percentage;
			};

			// Upload File
			fileApi.upload(uploadParams, callback, errorCallback, progressCallback);
		},
	},
};
</script>
